import type { VirtualSynthConfig } from "./types";

/**
 * YO! Monosynth - Virtual analog monosynth
 * Based on Moog Subsequent 37-style subtractive synthesis
 */
export const YO_MONOSYNTH_CONFIG: VirtualSynthConfig = {
  label: "YO! Monosynth",
  synthType: "MonoSynth",

  supportedCCs: [1, 7, 11, 16, 17, 18, 19, 20, 21, 70, 71, 72, 73, 74, 75, 76, 77, 78],

  profile: {
    id: "yo-monosynth-default",
    name: "Default",
    deviceName: "YO! Monosynth",
    userId: null,
    isPublic: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    ccConfig: [
      // === STANDARD MIDI CCs ===
      {
        number: 1,
        enabled: false,
        min: 0,
        max: 127,
        label: "Modulation",
      },
      {
        number: 7,
        enabled: false,
        min: 80,
        max: 110,
        label: "Volume",
      },
      {
        number: 11,
        enabled: false,
        min: 80,
        max: 110,
        label: "Expression",
      },
      {
        number: 74,
        enabled: true,
        min: 50,
        max: 110,
        label: "Filter Cutoff",
      },
      {
        number: 71,
        enabled: true,
        min: 0,
        max: 80,
        label: "Filter Resonance",
      },

      // === AMP ENVELOPE ===
      {
        number: 73,
        enabled: true,
        min: 3,
        max: 80,
        label: "Amp Attack",
      },
      {
        number: 75,
        enabled: true,
        min: 10,
        max: 127,
        label: "Amp Decay",
      },
      {
        number: 70,
        enabled: true,
        min: 0,
        max: 127,
        label: "Amp Sustain",
      },
      {
        number: 72,
        enabled: true,
        min: 10,
        max: 127,
        label: "Amp Release",
      },

      // === FILTER ENVELOPE ===
      {
        number: 16,
        enabled: true,
        min: 0,
        max: 127,
        label: "Filter Env Attack",
      },
      {
        number: 17,
        enabled: true,
        min: 0,
        max: 127,
        label: "Filter Env Decay",
      },
      {
        number: 18,
        enabled: true,
        min: 0,
        max: 127,
        label: "Filter Env Sustain",
      },
      {
        number: 19,
        enabled: true,
        min: 0,
        max: 127,
        label: "Filter Env Release",
      },
      {
        number: 20,
        enabled: true,
        min: 0,
        max: 70,
        label: "Filter Env Amount",
      },
      {
        number: 21,
        enabled: true,
        min: 20,
        max: 100,
        label: "Filter Env Base",
      },

      // === OSCILLATOR ===
      {
        number: 76,
        enabled: true,
        min: 0,
        max: 127,
        label: "Oscillator Type",
      },
      {
        number: 77,
        enabled: false,
        min: 0,
        max: 127,
        label: "Oscillator Detune",
      },
      {
        number: 78,
        enabled: false,
        min: 0,
        max: 127,
        label: "Portamento",
      },
    ],
  },
};
